import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { Box, LobbyWidget } from '@bonanza-social/moonlight';
import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectPrizeWallCampaignName,
  selectPrizeWallCampaignPromoIcon,
} from '../../state/prizeWallCampaign/prizeWallCampaign.slice';
import PrizeWallTokensInfo from '../PrizeWallTokensInfo/PrizeWallTokensInfo';
import PrizeWallImage from '../common/PrizeWallImage/PrizeWallImage';

function PrizeWallLobbyWidget() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const campaignName = useSelector(selectPrizeWallCampaignName);
  const promoIcon = useSelector(selectPrizeWallCampaignPromoIcon);

  const handleClick = useCallback(() => {
    navigation.navigate('Promos');
  }, [navigation]);

  return (
    <Box>
      <LobbyWidget label={campaignName || ''} onClick={handleClick} hasUnread>
        <PrizeWallImage {...promoIcon} width="100%" aspectRatio={1} />
      </LobbyWidget>
      <PrizeWallTokensInfo
        top={{
          mobile: '-space-200',
          tablet: 'space-0',
          desktop: 'space-0',
        }}
        right={{
          mobile: '-space-200',
          tablet: 'space-0',
          desktop: 'space-0',
        }}
        transform="translateY(-10px)"
        pointerEvents="none"
      />
    </Box>
  );
}

export default memo(PrizeWallLobbyWidget);
